/**
 */
define('constant/myservices/myservice.rollout.constant',[], function () {
return {
    //产品名称的下拉参数 服务类型-产品类型 : 自己独有的参数
    getProAbsListParam:{
        '4-19-1':{freeInstallType:1},
        '4-19-2':{freeInstallType:2},
        '40-1':{hasServiceItem:[6,8,32,33],parentType:13},
        '32-19-1':{freeInstallType:1},
        '32-19-2':{freeInstallType:2},
        '43-1':{hasServiceItem:[32]},
        '43-7':{hasServiceItem:[32]},
        '43-19-2':{hasServiceItem:[32],freeInstallType:2},
        '52-1':{parentType:2},
        '52-19-1':{parentType:2,freeInstallType:1},
        '52-19-2':{parentType:2,freeInstallType:2},
        '8-19-1':{freeInstallType:1},
        '8-19-2':{freeInstallType:2}
    },
    isNotShowNewProductBut:[3,43,40],
    packageListValues:{
        1:'appApks', 2:'appApks', 8:'appApks', 9:'appApks', 14:'themePkgList', 15:'wpPkgList', 19:'appRpks',17:'fontPkgList', 20:'dynamicWpPkgList', 23:'appRpks'
    },
    rpkListShowTypes:['4-19-1','4-19-2','24-23'],
    apkListShowTypes:["4-1","4-2","4-8","4-9","53-9","24-2"],
    themeListShowTypes:['30-14','30-15','30-17','30-20'],
    showCallbackUrl:[8, 32],
    showPackageName:[6,8,33,43,52, 32,59],
    showFingerPrint:[6,8,33, 32,52],
    needVerified:[6,59,43,26],
    productTypes:[
        {
            "type":'1',"name":"移动应用","serShow":[4,6,8,26,33,40,32,43,5,52,59]
        },
        {
            "type":'2',"name":"智慧屏应用","serShow":[8,24,32]
        },
        {
            "type":'7',"name":"服务器应用","serShow":[32,43]
        }
        ,{
            "type":'8',"name":"华为VR应用","serShow":[4,8,6,33,32,5]
        }
        ,{
            "type":'9',"name":"手表应用","serShow":[53]
        }
        ,{
            "type":'14',"name":"主题","serShow":[30]
        }
        ,{
            "type":'15',"name":"壁纸","serShow":[30]
        }
        ,{
            "type":'18',"name":"杂志锁屏图片","serShow":[45]
        }
        ,{
            "type":'19-1',"name":"快应用","serShow":[4,6,8,32,52]
        },
        {
            "type":'19-2',"name":"免安装/H5应用","serShow":[4,8,32,43,52],"whiteID":10
        } ,
        {
            "type":'21',"name":"AppTouch应用","switch":true,"serShow":[32]
        },{
            "type":'22',"name":"IOS移动应用","serShow":[32],"whiteID":13
        },
        {
            "type":'23',"name":"智慧屏快应用","serShow":[8,24,32]
        },
        {
            "type":'27',"name":"车机应用","serShow":[8,32,74]
        },
        {
            "type":'28',"name":"车机快应用","serShow":[8,32,74]
        },
        {
            "type":'30',"name":"云游戏","serShow":[]
        },
        {
            "type":'42',"name":"PC快应用","serShow":[32]
        }
    ],
    stepsConfByServiceItem: {
        '4': [{name: '选择产品包', mapState: ['rollout.selPkg']}, {
            name: '基础信息设置',
            mapState: ['rollout.appDetail','rollout.vrDetail','rollout.freeDetail']
        }, {name: '分发信息设置', mapState: ['rollout.appmarketServiceOnShelf']}, {
            name: '提交信息确认',
            mapState: ['rollout.appmarketServiceSubmit']
        }],//app gallery
        '5': [{name: '选择产品', mapState: ['rollout.selPkg']},
            {name: '基础信息设置',mapState: ['rollout.appDetail','rollout.vrDetail']},
            {name: '首发信息设置', mapState: ['rollout.firstPublishServiceDetail']},
            {name: '提交成功',mapState: ['rollout.submitSuccess']
        }],// 首发
        '53': [{name: '选择产品包', mapState: ['rollout.selPkg']},
            {name: '基础信息设置', mapState: ['rollout.watchDetail']},
            {name: '分发信息设置', mapState: ['rollout.watchMarketServiceOnShelf']},
            {name: '提交信息确认', mapState: ['rollout.watchMarketConfirmation']
        }],//手表应用市场
        '24': [{name: '选择产品包', mapState: ['rollout.selPkg']},
            {name: '基础信息设置', mapState: ['rollout.tvDetail']},
            {name: '分发信息设置', mapState: ['rollout.tvMarketServiceOnShelf']},
            {name: '提交信息确认', mapState: ['rollout.tvMarketConfirmation']
            }],//电视商城
        '30-15': [{name: '选择产品包', mapState: ['rollout.selThemePkg']},
            {name: '基础信息设置', mapState: ['rollout.wallpaperProduct']},
            {name: '分发信息设置', mapState: ['rollout.wallpaperService']},
            {name: '提交信息确认', mapState: ['rollout.themeWallpaperSummary']
            }], //wall paper
        '30-14': [{name: '选择产品包', mapState: ['rollout.selThemePkg']},
            {name: '分发信息设置', mapState: ['rollout.wallpaperService']},
            {name: '提交信息确认', mapState: ['rollout.themeWallpaperSummary']
            }], //theme
        '30-20': [{name: '选择产品包', mapState: ['rollout.selThemePkg']},
            {name: '基础信息设置', mapState: ['rollout.dynamicWpProduct']},
            {name: '分发信息设置', mapState: ['rollout.wallpaperService']},
            {name: '提交信息确认', mapState: ['rollout.themeWallpaperSummary']
            }], //动态壁纸,
        '30-17': [{name: '选择产品包', mapState: ['rollout.selThemePkg']},
            {name: '基础信息设置', mapState: ['rollout.fontProduct']},
            {name: '分发信息设置', mapState: ['rollout.wallpaperService']},
            {name: '提交信息确认', mapState: ['rollout.themeWallpaperSummary']
            }], //字体
        '40': [{name: '选择产品包', mapState: ['rollout.selPkg']},
            {name: '分发信息设置', mapState: ['rollout.preloadServiceDetail']},
            {name: '提交信息确认',mapState: ['rollout.preloadConfirmation']}],//preload
        '43': [{name: '设置运动健康服务信息', mapState: ['rollout.selPkg']}, {
            name: '提交成功',
            mapState: ['rollout.submitSuccess-intelligent']
        }],//运动健康
        '52': [{name: '设置游戏服务信息', mapState: ['rollout.selPkg']}, {
            name: '提交成功',
            mapState: ['rollout.submitSuccess']
        }], //Game
        '59': [{name: '设置HiAI服务信息', mapState: ['rollout.selPkg']}, {
            name: '提交成功',
            mapState: ['rollout.submitSuccess']
        }],//AI
        '8': [{name: '设置支付服务信息', mapState: ['rollout.selPkg']}, {
            name: '提交成功',
            mapState: ['rollout.submitSuccess']
        }], //IAP
        '32': [{name: '设置帐号服务信息', mapState: ['rollout.selPkg']},
                {name: '提交成功', mapState: ['rollout.submitSuccess']}
            ], //Huawei id
        '33': [{name: '设置社交服务信息', mapState: ['rollout.selPkg']}, {
                name: '提交成功', mapState: ['rollout.submitSuccess']
        }], //Message
        '6': [{name: '设置PUSH服务信息', mapState: ['rollout.selPkg']}, {
            name: '提交成功',
            mapState: ['rollout.submitSuccess']
        }], //Huawei push
        '26': [
            {name: '设置权签服务信息', mapState: ['rollout.selPkg']},{name: '提交成功', mapState: ['rollout.submitSuccess']}
        ]//权签
    }
}
});

